import type { Stats } from '../../types';
import { RetryDistributionChart } from './RetryDistributionChart';
import { SuccessRateChart } from './SuccessRateChart';

/**
 * The only thing outside this folder that touches Recharts.
 *
 * Everything drawn here is also rendered as text in the stats view, so deleting
 * `components/charts/` and the single `<ChartsPanel />` usage in StatsView loses
 * decoration, not information.
 */
export function ChartsPanel({ stats }: { stats: Stats }) {
  return (
    <section className="panel">
      <div className="panel__head">
        <h2 className="panel__title">Charts</h2>
        <p className="panel__lede">The same figures above, drawn.</p>
      </div>

      <div className="chart-grid">
        <figure className="chart">
          <figcaption className="chart__title">First attempt vs eventual success</figcaption>
          <SuccessRateChart
            firstAttempt={stats.successRate.firstAttempt}
            eventual={stats.successRate.eventual}
          />
        </figure>

        <figure className="chart">
          <figcaption className="chart__title">Deliveries settled on each attempt</figcaption>
          <RetryDistributionChart buckets={stats.retryDistribution} />
        </figure>
      </div>
    </section>
  );
}
